import { render } from "./ChitModifier.vue?vue&type=template&id=1e0987f2&scoped=true"
import script from "./ChitModifier.vue?vue&type=script&lang=js"
export * from "./ChitModifier.vue?vue&type=script&lang=js"

import "./ChitModifier.vue?vue&type=style&index=0&id=1e0987f2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0987f2"]])

export default __exports__